// extracted by mini-css-extract-plugin
export var content = "styles-module--content--de478";
export var image = "styles-module--image--d06ac";
export var text = "styles-module--text--6ec20";